import * as React from "react";
import classnames from "classnames";
import { MediaQuery } from "@grandvisionhq/common";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
/* empty css                                                                         */
/* empty css                                                                                                                   */
import "@grandvisionhq/elements";
import "@grandvisionhq/lib-utils-html";
import "@grandvisionhq/iris-ui";
import "@grandvisionhq/state";
import "@grandvisionhq/lib-visuals";
import "@grandvisionhq/utils";
/* empty css                                                                                                            */
/* empty css                                                                                           */
/* empty css                                                                                                             */
import "../../../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../../../state/state/actions.js";
import "../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../state/products/state/products/selectors.js";
import "../../../../../../state/products/state/products/reducer.js";
/* empty css                                                                                                                                                             */
/* empty css                                                                                                          */
import "@grandvisionhq/commercetools";
/* empty css                                                                                                                                      */
/* empty css                                                                                                                                         */
/* empty css                                                                                                                                                                 */
import "@grandvisionhq/icons";
/* empty css                                                                             */
/* empty css                                                                         */
/* empty css                                                                                              */
import { SelectionsSummary } from "../../../../../../components/SelectionsSummary/components/SelectionsSummary/SelectionsSummary.js";
/* empty css                       */
const DesktopStepLayout = ({ children, alternativeRightContent }) => {
  const isAboveTabletPortrait = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
  const { isFooterOpen } = useConfiguratorContext();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("desktop-step-layout", {
        "desktop-step-layout--summary-expanded": isFooterOpen
      })
    },
    /* @__PURE__ */ React.createElement("div", { className: "desktop-step-layout__left" }, /* @__PURE__ */ React.createElement("div", { className: "desktop-step-layout__content" }, children)),
    isAboveTabletPortrait && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "desktop-step-layout__divider" }), /* @__PURE__ */ React.createElement("div", { className: "desktop-step-layout__right" }, /* @__PURE__ */ React.createElement("div", { className: "desktop-step-layout__content" }, !!alternativeRightContent ? alternativeRightContent : /* @__PURE__ */ React.createElement(SelectionsSummary, null))))
  );
};
export {
  DesktopStepLayout as default
};
//# sourceMappingURL=DesktopStepLayout.js.map
